export default {
  getCurrencyString: float => float.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  getPercentageString: float => Math.round(float).toFixed(2),
};



// WEBPACK FOOTER //
// ./src/utils/Helper.js